import Vue from "vue";
import Vuex from "vuex";
import * as api from "../services/api";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {},
  mutations: {
    setLocation: (state, location) => (state.location = location)
  },
  actions: {
    async getLocation({ commit }, locationId) {
      const response = await api.getLocation(locationId);
      commit("setLocation", response.data);
    }
  },
  strict: debug
});
